import * as React from 'react';
import { useTheme, withThemeProvider } from '@narvar/nth-hook-theme';
import Alert from '@narvar/nth-block-alert';
import {
  useAnalyticsPost,
  NarvarEventTypes,
} from '@narvar/nth-hook-context-analytics';
import { LocationDetail } from '../../../server/api/schema';
import CustomComponentContext from '../CustomComponentContext';
import PickupLocationTemplate from './components/PickupLocationTemplate';

interface PickupLocationDetailsProps {
  featureName?: string;
  storeLocation?: LocationDetail | null;
}

// TODO: move this into nth-hook-context-analytics,
// as upgrading to @latest causes react dep conflicts
const NTH_PACK_PICKUP_POINT = 'nth-pack-pickup-point';

const PickupPointDetails: React.FunctionComponent<
  PickupLocationDetailsProps
> = ({ featureName, storeLocation }) => {
  const { signalContentLoaded } = React.useContext(CustomComponentContext);

  const logEvent = useAnalyticsPost();

  const { panelcontainerNoneNone: panelcontainerStyle } = useTheme();
  const { marginBottom } = panelcontainerStyle || {};

  signalContentLoaded?.();

  React.useEffect(() => {
    logEvent({
      eventComponent: NTH_PACK_PICKUP_POINT,
      eventFeature: NTH_PACK_PICKUP_POINT,
      eventType: NarvarEventTypes.COMPONENT_RENDER,
      feature: featureName,
      pageComponent: NTH_PACK_PICKUP_POINT,
    });
  }, []);

  if (!storeLocation) return null;

  return (
    <div
      style={{
        paddingBottom: marginBottom || '0.5rem',
        // TODO: remove when component is in `nth`.
        // hide until useTheme returns an actual value to avoid flash of defaults
        display: panelcontainerStyle ? 'block' : 'none',
      }}
    >
      <Alert featureName={featureName} show dismissible={false}>
        <div style={{ padding: '0.25rem' }}>
          <PickupLocationTemplate
            storeLocation={storeLocation}
            featureName={featureName}
          />
        </div>
      </Alert>
    </div>
  );
};

export default withThemeProvider(PickupPointDetails, {
  themeTokens: ['panelcontainerNoneNone'],
});
